const SCHEDULE_SCREEN_CONFIG = {
  "contact-tracing": {
    ignore: [
      {
        scheduleStateKey: "serviceSelection",
        compare: "NOT IN",
        value: "COVID_19_TEST"
      }
    ]
  },
  "influenza-screening": {
    ignore: [
      {
        scheduleStateKey: "serviceSelection",
        compare: "NOT IN",
        value: "FLU_SHOT"
      }
    ]
  },
  "influenza-consent": {
    ignore: [
      {
        scheduleStateKey: "serviceSelection",
        compare: "NOT IN",
        value: "FLU_SHOT"
      }
    ]
  },
  insurance: {
    ignore: [
      {
        scheduleStateKey: "collectInsurance",
        compare: "EQ",
        value: false
      }
    ]
  },
  "insurance-card": {
    ignore: [
      {
        scheduleStateKey: "hasInsurance",
        compare: "EQ",
        value: false
      },
      {
        scheduleStateKey: "collectInsurance",
        compare: "EQ",
        value: false
      }
    ]
  },
  "insurance-verification": {
    ignore: [
      {
        scheduleStateKey: "insurancePhoto",
        compare: "EQ",
        value: ""
      },
      {
        scheduleStateKey: "hasInsurance",
        compare: "EQ",
        value: false
      },
      {
        scheduleStateKey: "collectInsurance",
        compare: "EQ",
        value: false
      }
    ]
  },
  "public-places": {
    ignore: [
      {
        scheduleStateKey: "serviceSelection",
        compare: "NOT IN",
        value: "COVID_19_TEST"
      }
    ]
  },
  consent: {
    ignore: [
      {
        scheduleStateKey: "serviceSelection",
        compare: "NOT IN",
        value: "COVID_19_TEST"
      }
    ]
  },
  pregnancy: {
    ignore: [
      {
        scheduleStateKey: "gender",
        compare: "EQ",
        value: "male"
      }
    ]
  },
  "time-appointment-two": {
    ignore: [
      {
        scheduleStateKey: "singleDoseVax",
        compare: "EQ",
        value: true
      }
    ]
  },
  "covid19-test-type": {
    ignore: [
      {
        scheduleStateKey: "multipleTestTypesAvailable",
        compare: "EQ",
        value: false
      }
    ]
  },
  occupation: {
    ignore: [
      {
        scheduleStateKey: "locationState",
        compare: "NEQ",
        value: "NY"
      }
    ]
  }
};

export { SCHEDULE_SCREEN_CONFIG };
